import "../../assets/css/Category.css";

const CategoryComps = () => {
  return (
    <>
      <div id="categori">
        <div className="service-content">
          <div className="service-grid text-center">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="main-title text-center wow fadeIn">
                    <h3 className="fw-bold">CATEGORY</h3>
                    <div className="underline1"></div>
                    <div className="underline2 mb-5"></div>
                  </div>
                </div>
              </div>
              <div className="row love-row wow fadeIn mt-5">
                <div className="col-md-3 col-sm-6">
                  <div className="service-details" data-wow-delay=".1s">
                    <div className="service-head">
                      <img src="./assets/images/icon/entrepreneurship.png" alt="Enterpreneurship"></img>
                    </div>
                    <div className="service-bottom">
                      <h3>Enterpeneur</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="service-details" data-wow-delay=".1s">
                    <div className="service-head">
                    <img src="./assets/images/icon/iot.png" alt="Electronics and IoT"></img>
                    </div>
                    <div className="service-bottom">
                      <h3>Electronics and IoT</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="service-details" data-wow-delay=".1s">
                    <div className="service-head">
                        <img src="./assets/images/icon/biology.png" alt="Pure Science"></img>
                    </div>
                    <div className="service-bottom">
                      <h3>Pure Science</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="service-details" data-wow-delay=".1s">
                    <div className="service-head">
                        <img src="./assets/images/icon/engineering.png" alt="Physics and Engineering"></img>
                    </div>
                    <div className="service-bottom">
                      <h3>Physics and Engineering</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="service-details" data-wow-delay=".1s">
                    <div className="service-head">
                        <img src="./assets/images/icon/education.png" alt="Education"></img>
                    </div>
                    <div className="service-bottom">
                      <h3>Education</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="service-details" data-wow-delay=".1s">
                    <div className="service-head">
                        <img src="./assets/images/icon/network.png" alt="Social Science"></img>
                    </div>
                    <div className="service-bottom">
                      <h3>Social Science</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="service-details" data-wow-delay=".1s">
                    <div className="service-head">
                        <img src="./assets/images/icon/life.png" alt="Life Sciences"></img>
                    </div>
                    <div className="service-bottom">
                      <h3>Life Sciences</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="service-details" data-wow-delay=".1s">
                    <div className="service-head">
                    <img src="./assets/images/icon/creativity.png" alt="Innovation Sciences"></img>
                    </div>
                    <div className="service-bottom">
                      <h3>Innovation Sciences</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-3 col-sm-6">
                  <div className="service-details" data-wow-delay=".1s">
                    <div className="service-head">
                      <i class="fa-solid fa-clapperboard fa-6x"></i>
                    </div>
                    <div className="service-bottom">
                      <h3>Animation</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryComps;
